<style scoped>
.dropdown-menu::after,
.dropdown-menu::before {
  content: none;
}
</style>

<template>
  <td>
    <div
      v-if="!model.deleted_at"
      ref="dropdown"
      class="dropdown"
      :class="{ show: show, dropup: index > 10, dropleft: true }"
    >
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div
          @click="$modal.show(editAllowOriginModalName)"
          class="dropdown-item"
        >
          Bearbeiten
        </div>
        <div @click="remove" class="dropdown-item">Löschen</div>
      </div>
    </div>

    <modal
      :name="editAllowOriginModalName"
      :maxWidth="600"
      width="90%"
      height="auto"
      :adaptive="true"
      style="overflow: hidden"
    >
      <section class="p-3">
        <div class="form-group">
          <textarea class="form-control" v-model="domain"></textarea>
        </div>
        <button
          @click="updateAllowedDomain()"
          type="button"
          class="btn btn-primary"
        >
          Speichern
        </button>
      </section>
    </modal>
  </td>
</template>

<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  props: ["model", "tableId", "index"],
  data() {
    return {
      show: false,
      deleting: false,
      domain: this.model.domain
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  computed: {
    id() {
      return this.model.id;
    },
    editAllowOriginModalName() {
      return `${this.id}-edit-access-control-allow-origin-modal`;
    }
  },
  methods: {
    remove() {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }

      this.deleting = true;

      this.$store
        .dispatch("accessControlAllowOrigin/delete", {
          url: this.model.delete_url,
          id: this.id
        })
        .then(() => {
          this.$emit("table-update", { count: true });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    updateAllowedDomain() {
      this.disableModalActions = true;
      this.$http
        .patch("/api/v1/accessControlAllowOrigin/" + this.id, {
          id: this.id,
          domain: this.domain
        })
        .then(() => {
          this.$modal.hide(this.editAllowOriginModalName);
          this.$notify({
            title: "Zugelassene Domain wurde geupdated",
            type: "success"
          });
          this.$emit("table-update", { count: true });
        })
        .finally(() => {
          this.disableModalActions = false;
        });
    }
  }
};
</script>
